
function SeedSgridController($scope, $rootScope, $mdDialog, $uibModal, $filter, TranslationService, SdSgridService, $window, ToastService, AllocService, WorkflowService, $routeParams, $location) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.months = AllocService.getNextMonths();

    ctrl.filterItem = function (item) {
        if (!item) {
            return true;
        }
        return true;
    };

    ctrl.customFilterCheck = function (item) {
        if (ctrl.prefs.customFilter) {
            return ctrl.prefs.customFilter(item);
        } else {
            return true;
        }
    }; 

    $scope.$on('inputSearch', function (event, eventArgs) {
        ctrl.searchMode(eventArgs);
    });

    $scope.$on('toExcel', function (event, eventArgs) {
        var toastID = ToastService.createToast('Exportando para Excel', '', 0, 'wait');
        ctrl.loadService(ctrl.filterString, ctrl.options, 0, 99999, ctrl.sort, ctrl.prefs.parentFilter).then(function (response) {
            if (!ctrl.prefs.customExcel) {
                alasql('SELECT * INTO XLSX("' + eventArgs + '.xlsx", {header:true}) FROM ?', [response.data]);
            } else {
                ctrl.prefs.customExcel(response.data, eventArgs);
            }
            ToastService.removeToast(toastID);
            ToastService.createToast('Exportado', '', 4000, 'success');
        });
    });

    ctrl.searchMode = function (search) {
        ctrl.filterString = search;
        ctrl.noData = false;
        ctrl.skipNumber = 0;
        ctrl.items = [];
        ctrl.loadItems(false);
    };

    //console.log('set filter string');
    if (!ctrl.filterString) {
        ctrl.filterString = '';
    }    
    ctrl.sort = { column: '', reverse: false };
    ctrl.skipNumber = 0;
    ctrl.takeNumber = 50;
    ctrl.options = SdSgridService.getAppliedFilters(ctrl.prefs.name);
    ctrl.appliedFilters = SdSgridService.getAppliedFilters(ctrl.prefs.name);
    ctrl.filters = SdSgridService.getFilters(ctrl.prefs.name);
    ctrl.items = [];

    ctrl.filterOptions = function () {
        ctrl.noData = false;
        ctrl.options = ctrl.appliedFilters;
        ctrl.skipNumber = 0;
        ctrl.loadItems(false);
    };

    ctrl.tryLoadItemToEdit = function () {
        var itemToEdit = null;
        if ($routeParams.edit) {
            if ($location.path().includes("Orders")) {
                itemToEdit = ctrl.items.find(function (e) {
                    return e.OrderID === $routeParams.edit
                });
            }
        }

        if (itemToEdit) {
            ctrl.editItem(null, null, itemToEdit);
            setTimeout(function () {
                $location.search('edit', null);
            });
        }
        else {
            $location.search('edit', null);
        }
    };

    ctrl.loadItems = function (scroll) {
        //console.log('ctrl.loadItems: ' + scroll + ' filter: ' + ctrl.filterString);
        if (!ctrl.noData) {
            ctrl.itemsLoaded = null;
            if (ctrl.loading == true || ctrl.loadingScroll == true)
                return;

            if (scroll == false)
                ctrl.loading = true;
            else if (scroll == true)
                ctrl.loadingScroll = true;

            ctrl.loadService(ctrl.filterString, ctrl.options, ctrl.skipNumber, ctrl.takeNumber, ctrl.sort, ctrl.prefs.parentFilter).then(
                function (response) {
                    if (response.data) {
                        if (response.data.length == 0)
                            ctrl.noData = true;
                        else
                            ctrl.noData = false;

                        if (!scroll) {
                            ctrl.items = response.data;
                        } else {
                            for (var i = 0; i < response.data.length; i++) {
                                ctrl.items.push(response.data[i]);
                            }
                            ctrl.loadingScroll = false;
                        }

                        if (!ctrl.noData)
                            ctrl.skipNumber += ctrl.takeNumber;

                        if (ctrl.prefs.postProcessing)
                            ctrl.prefs.postProcessing(response.data);

                        
                        ctrl.itemsLoaded = ctrl.items.length;

                        //console.log('------------------------------------------');
                        //console.log('SDSGRID -> ' + ctrl.itemsLoaded);
                        //console.log('------------------------------------------');


                        ctrl.prefs.items = ctrl.items;
                        ctrl.loading = false;

                        ctrl.tryLoadItemToEdit();
                    }
                },
                function (err) {
                    ctrl.loading = false;
                    console.log('Error loading grid');
                    //console.log(err);
                }
            );

        }
    };

    
    if (!ctrl.prefs.disableLoadItems) {
        ctrl.loadItems(false);
    }
    else {
        //console.log('SGRID.disableLoadItems');
    }

    $scope.$on('refreshServiceGrid', function (event, eventArgs) {
        ctrl.doRefresh();
    });

    ctrl.doRefresh = function () {
        ctrl.noData = false;
        ctrl.skipNumber = 0;
        ctrl.resetService();
        ctrl.loadItems(false);
    };

    $scope.$on('addItem', function (event, eventArgs) {
        ctrl.editItem(eventArgs, ctrl.columns, null);
    });

    ctrl.openModelEdit = function (cols, item) {
        var modalInstance = $uibModal.open({
            templateUrl: '/SPA/Components/grid/sd-grid-edit.html',
            controller: 'EditItemCtrl',
            size: 'md',
            resolve: {
                cols: function () {
                    return cols;
                },
                item: function () {
                    return item;
                }
            }
        });

        modalInstance.result.then(function (newItem) {
            if (newItem) {
                item = newItem;
                ctrl.saveItem(item);
            }
        });
    };

    ctrl.columnClick = function (col, value, obj) {
        if (col.onClick) {
            event.stopPropagation();
            col.onClick(value, obj);
            return true;
        } else if (col.link) {
            event.stopPropagation();
            $window.open(obj.Link, '_blank');
        } else {
            return false;
        }
    };

    ctrl.editItem = function (event, cols, item) {
        if (ctrl.prefs.customEdit && (ctrl.prefs.canAdd || ctrl.prefs.canEdit)) {
            ctrl.prefs.customEdit(item);
            return;
        }
        if (item) {            
            if (!ctrl.prefs.canEdit) {
                return;
            }
        }
        else {
            if (!ctrl.prefs.canAdd) {
                return;
            }
        }
        if (!item) {
            item = {
                IsNew: true,
            };
        }
        ctrl.openModelEdit(cols, item);
    };

    ctrl.saveItem = function (item) {
        if (item) {
            if (ctrl.prefs.saveItem) {
                ctrl.prefs.saveItem(item);
            }
        }
    };

    ctrl.removeConfirmation = function (item) {
        var modalInstance = $uibModal.open({
            templateUrl: '/SPA/Components/grid/sd-grid-remove.html',
            controller: 'RemoveConfirmationCtrl',
            size: 'md',
            resolve: {
                item: function () { return item; },
                prefs: function () { return ctrl.prefs;}
            }
        });
        modalInstance.result.then(function () {});
    };

    ctrl.sortBy = function (col) {
        ctrl.noData = false;
        ctrl.sort.column = col.name;
        ctrl.skipNumber = 0;
        ctrl.items = [];
        var reverse;
        if (col.sortType == 'asc')
            reverse = false;
        else if (col.sortType == 'desc')
            reverse = true;
        else 
            ctrl.sort.column = '';
        ctrl.sort.reverse = reverse;
        ctrl.loadItems(false);
    };


    ctrl.filterSelected = function (col) {
        var options = col.filterOptions;
        var name = col.name;
        var id = col.id;
        var display = col.display;
        var dataType = col.dataType;
        for (var i = ctrl.filters.length - 1; i > -1; i--) {
            if (ctrl.filters[i].name == name) {
                ctrl.filters.splice(i, 1);
            }
        }
        for (var k = 0; k < options.length; k++) {
            options[k].name = name;
            options[k].id = id;
            options[k].display = display;
            options[k].dataType = dataType;
            ctrl.filters.push(options[k]);
        }
        ctrl.handleFilters();
    };

    ctrl.handleFilters = function () {
        SdSgridService.setFilters(ctrl.prefs.name, ctrl.filters);
        ctrl.appliedFilters = [];
        var result = ctrl.filters.reduce(function (r, a) {
            r[a.name] = r[a.name] || [];
            r[a.name].push(a);
            return r;
        }, Object.create(null));
        for (var i in result) {
            ctrl.appliedFilters.push(result[i]);
        }
        SdSgridService.setAppliedFilters(ctrl.prefs.name, ctrl.appliedFilters);
        ctrl.filterOptions();
    };

    ctrl.deleteFilter = function (filter) {
        ctrl.sort.column = '';
        var index = ctrl.appliedFilters.indexOf(filter);
        ctrl.appliedFilters.splice(index, 1);
        $rootScope.$broadcast('delete_filter', filter);
    };

    ctrl.getColStyle = function (col) {
        if (col.showLeftBorder) {
            return 'border-left: 1px solid #ddd;'
        }
        else if (col.dataType == 'number') {
            return 'text-align: right;'
        }
    };

    ctrl.isExpired = function (expDate) {
        return AllocService.isExpired(expDate);
    };

    ctrl.getExpiredClass = function (expDate) {
        return AllocService.getExpiredClass(expDate);
    };

    ctrl.nextDay = function (expDate) {
        if (!expDate) {
            return null;
        }
        return new Date(expDate.getUTCFullYear(), expDate.getUTCMonth(), expDate.getUTCDate() + 1);
    };

    ctrl.statusIDClass = function (item) {
        return 'status-card Status' + item;
    };

    $scope.editExpiredJustification = function (order) {

        AllocService.editExpiredJustification(order).result.then(function (response) {
            order.ExpiredJustification = response;
        });
    }

    ctrl.getTranslation = function (name) {
        if (ctrl.translation &&  ctrl.translation[name]) {
            return ctrl.translation[name];
        }
        else {
            return '[' + name + ']'
        }
    }

    ctrl.canShowExpirationDate = function (item) {
        return WorkflowService.canShowExpirationDate(item);
    };

    ctrl.isJustificationNeeded = function (item) {
        return WorkflowService.isJustificationNeeded(item);
    };

    ctrl.toggleSelectAll = function () {
        //console.log('toggleSelectAll');
        checkOrUncheck();
        ctrl.selectedRows = getSelectedRows();
        ctrl.numberRowsSelected = getNumberRowsSelected();
    };

    function checkOrUncheck() {
        ctrl.items.map(function (item) {
            if (item.selected)
                item.selected = false;
            else
                item.selected = true;
        });
    }

    function getSelectedRows() {
        var selectedItems = ctrl.items.filter(function (item) {
            return item.selected;
        });
        return selectedItems;
    }

    function getNumberRowsSelected() {
        return ctrl.selectedRows.length;
    }

    ctrl.toggleSelect = function (item) {
        //item.selected = !item.selected;

        //console.log('toggleSelect');

        ctrl.recalcSelected();
        /*
        if (ctrl.prefs.selectedCount) {
            ctrl.prefs.selectedCount++;
        }
        else {
            ctrl.prefs.selectedCount = 1;
        }
        */
    };

    ctrl.recalcSelected = function () {
        ctrl.selectedCount = 0;
        ctrl.items.forEach(function (item) {
            if (item.selected) {
                ctrl.selectedCount++;
            }
        })
    };

    ctrl.openColumnFilter = function (filter) {
        //console.log('openColumnFilter ', filter);
        var name = filter[0].name;
        var col = ctrl.columns.find(function (col) {
            return col.name == name;
        });
        if (col) {
            $scope.$broadcast('onTogleFilter', col);
        }
    };

    $scope.$on('clearSelected', function () {
        //console.log('ON clearSelected');
        ctrl.items.map(function (item) {
            if (item.selected) {
                item.selected = false;
            }
            return item;
        })
        ctrl.recalcSelected();
    });

    $scope.$on('columnsChange', function (event, columns) {
        ctrl.columns = columns;
        ctrl.doRefresh();
    });

    
}

SeedSgridController.$inject = ['$scope', '$rootScope', '$mdDialog', '$uibModal', '$filter', 'TranslationService', 'SdSgridService', '$window', 'ToastService', 'AllocService', 'WorkflowService', '$routeParams', '$location'];

seedWebApp.component('sdSgrid', {
    controller: SeedSgridController,
    bindings: {
        prefs: '<',
        columns: '<',
        overflowSize: '<',
        customFilter: '&',
        loadService: '<',
        loadColumn: '<',
        resetService: '<',
        itemsLoaded: '=',        
        contactId: '<',       
        selectedCount: '=',
        filterString: '<',       
    },
    templateUrl: '/SPA/Components/serviceGrid/sd-sgrid.html' + seedWebApp.buildVersion
});